// localstoragedb
// low-level api to interface neomem with localstorage

import { User, UserId, INode, FieldId, NodeId, NodeValue, Pattern, Cache } from '../../types'
import { Datastore } from '../types'


export class LocalStorageDb implements Datastore {

  type = 'localStorageDb'
  currentUserId: string|undefined
  nodes: Cache = {}

  constructor() {
  }


  // -----------------------------------------------------
  // users
  // -----------------------------------------------------

  // these aren't really needed, but they need to be part of cloud db interface
  setCurrentUserId(userId: UserId) {
    this.currentUserId = userId
  }
  getCurrentUserId() {
    return this.currentUserId
  }

  // no-op
  async createUser(user: User) {
    return user
  }

  // user always exists
  async getUser(userId: UserId) {
    return {id:userId}
  }

  // no-op
  async deleteUser(userId: UserId) {
  }


  //----------------------------------------------------------------------
  // get nodes
  //----------------------------------------------------------------------

  //. ignore pattern, just get them all
  async getNodes(pattern: Pattern) {
    const s = window.localStorage.getItem('nodes') || '{}'
    const nodes = JSON.parse(s)
    console.log('load from localstorage', nodes)
    this.nodes = nodes // save in our cache also
    //. convert to an unordered list
    const nodesList = Object.keys(this.nodes).map(id => ({...this.nodes[id]}))
    return nodesList
  }

  async saveNodes(nodes: INode[]) {
    for (let node of nodes) {
      await this.createNode(node)
    }
  }

  async clearNodes() {
    this.nodes = {}
    this.saveCache()
  }

  // // get list of nodes in db format
  // // pattern can be eg {typeId:'place'}, {parentId:'welcome'}, combinations, etc
  // async getNodes(pattern = {}) {
  //   const nodes = Object.keys(this.nodes).map(id => {
  //     const node = {... this.nodes[id], id }
  //     return node
  //   })
  //   return nodes
  // }

  //. this is specific to localstorage
  private saveCache() {
    console.log('save to localstorage', this.nodes)
    const s = JSON.stringify(this.nodes)
    window.localStorage.setItem('nodes', s)
  }


  // -----------------------------------------------------
  // nodes
  // -----------------------------------------------------
  // crud - create retrieve update delete

  async createNode(node: INode) {
    this.nodes[node.id] = {...node}
    this.saveCache()
    return node
  }

  // async getNode(nodeId: NodeId) {
  //   const node = this.nodes[nodeId]
  //   return node
  // }

  async deleteNode(nodeId: NodeId) {
    delete this.nodes[nodeId]
    this.saveCache()
  }

  
  //----------------------------------------------------------------------
  // node values
  //----------------------------------------------------------------------

  // async getNodeValue(nodeId: NodeId, fieldId: FieldId) {
  //   const node = this.nodes[nodeId] //. need to make copy?
  //   return node[fieldId]
  // }

  setNodeValue(nodeId: NodeId, fieldId: FieldId, value: NodeValue) {
    if (this.nodes[nodeId]) {
      this.nodes[nodeId][fieldId] = value
      this.saveCache()
    }
  }

  // setNodeValues(nodeId: NodeId, obj) {
  //   for (let key of Object.keys(obj)) {
  //     this.setNodeValue(nodeId, key, obj[key])
  //   }
  // }

  async deleteNodeValue(nodeId: NodeId, fieldId: FieldId) {
    if (this.nodes[nodeId]) {
      delete this.nodes[nodeId][fieldId]
      this.saveCache()
    }
  }

}
